import { defineStore } from "pinia";
import { fetchMatchStats } from "../services/matches.service";
import { Competition } from "../models/competition";
import { Match, Stats } from "./../models/match";
import { upsertEntities } from "./utils";
import { useErrorStore } from "./error.store";

interface MatchStatsState {
  ids: string[];
  entities: { [id: string]: Stats };
}

export const useMatchStatsStore = defineStore("matchStats", {
  state: (): MatchStatsState => ({
    ids: [],
    entities: {},
  }),
  actions: {
    async fetchMatchStats(match: Match, competition: Competition): Promise<void> {
      try {
        const stats = await fetchMatchStats(match, competition);
        this.fetchMatchStatsSuccess(stats);
      } catch (error) {
        this.fetchMatchStatsError(error);
      }
    },

    fetchMatchStatsSuccess(stats: Stats): void {
      upsertEntities([stats], this);
    },

    fetchMatchStatsError(err: any): void {
      const errorStore = useErrorStore();
      errorStore.throwError(`fetchMatchStatsError: ${err.toString()}`);
    },
  },
});
